import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'allocationusername'})
export class AllocationUserName implements PipeTransform {

  public transform(value) {
    if (value) {
        return value;
    } else {
        return 'ROUTES.EVENTDETAIL.FRONTDESK.Unallocated.LABEL';
    }
  }
}
